// src/App.tsx
import React from 'react';
//import '../tailwind.css';
//import '../styles/pixelationism.css';
import Pixelator from '../components/Pixelator';
import CustomCursor from '../components/CustomCursor';

const Pixelationism: React.FC = () => {
  return (
    <div className="pixelationism w-full h-full flex content-center p-12 text-4xl font-[Aktiv Grotesk] bg-[#111111] text-[#FEFDFB]">
      <div className='cursor-none h-full w-full content-center select-none'>
      {/* <CustomCursor />
      <Pixelator>
        At Koalition
      </Pixelator>
      <Pixelator>
        Every pixel matters —
      </Pixelator>
      <Pixelator>
        Every interaction counts
      </Pixelator> */}
      </div>
    </div>
  );
};

export default Pixelationism;
